module.exports = __webpack_public_path__ + "media/images/top/scene04-fa46320103d602a3ab05d2f502fe05ad.jpg";